import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=0f7ea24b&scoped=true"
import script from "./TemplateTable.vue?vue&type=script&lang=js"
export * from "./TemplateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ea24b",
  null
  
)

export default component.exports